import { render, staticRenderFns } from "./SidebarMenuItem.vue?vue&type=template&id=0026ab24&scoped=true"
import script from "./SidebarMenuItem.vue?vue&type=script&lang=js"
export * from "./SidebarMenuItem.vue?vue&type=script&lang=js"
import style0 from "./SidebarMenuItem.vue?vue&type=style&index=0&id=0026ab24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0026ab24",
  null
  
)

export default component.exports